var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.lesson
    ? _c(
        "SoliAvatarBtn",
        {
          staticClass: "justify-center",
          attrs: {
            title: `${_vm.lesson.instrument.name} Lesson w/ ${_vm.lesson.teacher.name}`,
            avatar: _vm.lesson.teacher.profile_photo_url,
            subtitleTop: `${_vm.globalMomentLocalLongDate(
              _vm.lesson.starts_at
            )} at ${_vm.globalMomentTime(_vm.lesson.starts_at)}`,
            subtitleBottom: `${_vm.lesson.duration} min | ${
              _vm.lesson.location.name
            } | ${_vm.lesson.online ? "Online" : "In-Person"}`,
            blueShadow: "",
            disabled: "",
            size: "84",
            ripple: false,
          },
        },
        [
          [
            _c(
              "Link",
              {
                staticClass: "flex",
                class:
                  _vm.$vuetify.breakpoint.width >= 375
                    ? "justify-start"
                    : "justify-center",
                staticStyle: { "text-transform": "none" },
                attrs: {
                  href: _vm.route("getStarted.bookNow", {
                    location: _vm.guest.location,
                  }),
                  data: { requestChange: true },
                },
              },
              [_vm._v("Need to make a change?")]
            ),
          ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }